import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ChatModalContent } from '../components/Chat/ChatModalContent';
import { useChatStore } from '../stores/chatStore';

/**
 * MessagesPage - Full screen inbox/chat page
 */
export default function MessagesPage() {
    const { pubkey } = useParams<{ pubkey?: string }>();
    const { setActiveConversation } = useChatStore();

    useEffect(() => {
        if (pubkey) {
            setActiveConversation(pubkey);
        }
    }, [pubkey, setActiveConversation]);

    return (
        <div className="h-full w-full overflow-hidden bg-white dark:bg-surface-900">
            <ChatModalContent variant="page" />
        </div>
    );
}
